// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__tptog","header":"ReportDetails_header__1IYLx","title":"ReportDetails_title__1pNnp","left":"ReportDetails_left__3QebP"};